import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../public/media/logos/ed002-principal.png'


const _hoisted_1 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: _imports_0,
  class: "h-50px w-200px logo"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  id: "kt_aside_toggle",
  class: "btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle",
  "data-kt-toggle": "true",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body",
  "data-kt-toggle-name": "aside-minimize"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1 rotate-180" }
const _hoisted_9 = { class: "aside-menu flex-column-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable", [
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: '/dashboard' }, {
        default: _withCtx(() => [
          (_ctx.asideTheme === 'dark')
            ? (_openBlock(), _createElementBlock("a", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: '/dashboard' }, {
        default: _withCtx(() => [
          (_ctx.asideTheme === 'light')
            ? (_openBlock(), _createElementBlock("a", _hoisted_5, [
                _createElementVNode("img", {
                  alt: "Logo",
                  src: _ctx.lightLogo,
                  class: "h-25px logo"
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr080.svg" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_KTMenu)
    ])
  ], 2))
}